import { useEffect } from "react";
import Routing from "./routes/Routing";
import ErrorBoundary from "./components/ErrorBoundary";
import { loadSiteTheme } from "./utils/siteTheme";
import { AppFeedbackProvider } from "./context/AppFeedbackContext";

import "swiper/css";
import "swiper/css/pagination";

function App() {
  useEffect(() => {
    loadSiteTheme();
  }, []);

  return (
    <AppFeedbackProvider>
      <ErrorBoundary>
        <Routing />
      </ErrorBoundary>
    </AppFeedbackProvider>
  );
}

export default App;
